module.exports = __webpack_public_path__ + "static/img/sing-name.1fc8e3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/sing-name.jpg
// module id = 6r7g
// module chunks = 9